import { createIconComponent } from '../../factory/create-icon-component';
export const GreatherThanSignIcon = createIconComponent(
  'GreatherThanSignIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.74994 19.7501L19.7499 12.2501L4.74994 4.75012"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
